import React from 'react';
import styles from "./animation.module.css"

  export default class InfoButton extends React.Component {
	render (){
		return (
					<div className={styles[`infoButton`]} style={{width:'134px',
								 height:'34px',
								 background:'#1894f3',
								 boxShadow: 'rgba(0, 0, 0, 0.20) 0px 5px 20px',
								 borderRadius:'12px',
								 cursor:'pointer'
								}}>
				    
				    <h1 style={{fontFamily:'Droid Sans',
				    			fontWeight: '700',
				    			fontSize:'12px',
				    			textAlign:'center',
				    			textTransform:'uppercase',
				    			textDecoration:'none',
				    			paddingTop:'11px',
				    			color:'#fff'
				    			}}>

								Online Portfolio

								</h1>
					 </div>
			)
	}
}

